// 用“导入”命令加载VUE构建版本
// 在WebPACK.BASE.CONF中设置了别名（运行时单独或运行时）
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
// import Axios from 'axios'
import Global from './components/Global'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import CKEditor from 'ckeditor4-vue'
// 数据图表
import VueApexCharts from 'vue-apexcharts'
// 接口地址全局封装
import VueApi from './api/api'
Vue.prototype.$api = VueApi
// 引入加载组件（加载状态）
import EleLoading from '@/components2/theme/common/element/EleLoading'
// 引入按钮组件（按钮样式）
import EleButton from '@/components2/theme/basics/layout/ZdyButton'
// 引入图标组件（图标样式）
import SvgIcon from '@/components2/theme/common/icon/SvgIcon'
// 公共方法
import methods from '@/components2/utils/methods';

// 全局样式库
import '@/components2/css/ownKK.css';
import '@/assets/css/style.css';


Vue.prototype.$METHODS = methods

// 复制组件
Vue.use(VueClipboard)
// 数据图表
Vue.use(VueApexCharts)
Vue.component('apexChart', VueApexCharts)
// 其它定义
Vue.use(ElementUI)
Vue.use(CKEditor)
// 引入图片预览组件
// import hevueImgPreview from 'hevue-img-preview'
// Vue.use(hevueImgPreview)
Vue.component('svg-icon', SvgIcon)
Vue.component('zdy-button', EleButton)
Vue.component('ele-loading', EleLoading)
Vue.config.productionTip = false
// Vue.prototype.$Axios = Axios
Vue.prototype.$GLOBAL = Global
console.log(Vue.prototype.$GLOBAL, 'Vue.prototype.$GLOBAL');

// 判断当前环境使用地址
if (process.env.NODE_ENV !== 'development') {
  Vue.prototype.$NewUrl = window.location.href.split(':')[0] + '://' + window.location.host + '/admin'
  Vue.prototype.$JavaUrl = 'https://teaching.xiaosuanmiao.cn/'
} else {
  Vue.prototype.$NewUrl = '/api/admin'
  Vue.prototype.$JavaUrl = '/javaApi'
}

// 公用跳转页面 type[name, link, path]
Vue.prototype.GoToPage = function (name, params = 0, type = 'name') {
  // 拦截查询权限
  let power = this._AsIntercept(name.replace('../', ''))
  if (power === false) {
    this.$notify.error({title: '您没有权限操作', message: '权限不足'})
    this.$router.push({name: 'ErrorCode'})
    return false
  }
  if (name === this.$router.history.current.name) return
  // 前往页面
  if (type === 'name') {
    this.$router.push({name: name})
  } else if (type === 'link') {
    window.open(name)
  } else {
    this.$router.push(name + '/' + params)
  }
}
// 跳页面拦截处理
Vue.prototype._AsIntercept = function (name) {
  // 判断权限开关
  if (this.$GLOBAL.PowerSwitch === false) {
    return true
  }
  let power = false
  if (this.$GLOBAL.routePower.includes(name)) {
    power = true
  }
  return power
}

// 存值
Vue.prototype.storageSet = function (key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}
// 查值
Vue.prototype.storageGet = function (key) {
  return JSON.parse(localStorage.getItem(key))
}
// 删值
Vue.prototype.storageDel = function (value) {
  localStorage.removeItem(value)
}

// 密码强度
Vue.prototype.passStrength = function (sValue) {
  let modes = 0
  // 正则表达式验证符合要求的
  if (sValue.length < 1) return modes
  if (/\d/.test(sValue)) modes++ // 数字
  if (/[a-z]/.test(sValue)) modes++ // 小写
  if (/[A-Z]/.test(sValue)) modes++ // 大写
  if (/\W/.test(sValue)) modes++ // 特殊字符
  // 逻辑处理
  switch (modes) {
    case 4:
      return sValue.length < 4 ? 3 : 4
    default:
      return modes
  }
}

// 文件大小转换 （这里的大小默认给的是KB）
Vue.prototype.sizeTurn = function (size) {
  let kb = 1024
  let mb = 1024 * kb
  let gb = 1024 * mb
  let New = ''
  if (size < kb) {
    return (size % 1 === 0) ? size + ' KB' : size.toFixed(2) + ' KB'
  } else if (size < mb) {
    New = size / kb
    return (New % 1 === 0) ? New + ' MB' : New.toFixed(2) + ' MB'
  } else if (size < gb) {
    New = size / mb
    return (New % 1 === 0) ? New + ' GB' : New.toFixed(2) + ' GB'
  }
}

// 时间日期
Vue.prototype.nowDate = function (format) {
  let nowDate = new Date(format)
  let getMonth = parseInt(nowDate.getMonth() + 1)
  // 开始
  let year = nowDate.getFullYear()
  let month = (getMonth > 9) ? getMonth : '0' + getMonth
  let date = (nowDate.getDate() > 9) ? nowDate.getDate() : '0' + nowDate.getDate()
  return year + '-' + month + '-' + date
}

// 展示数据结构 [1.表单结构 2.接口结构]
Vue.prototype.structureShow = function (grForms, res) {
  grForms.forEach((items) => {
    if (items.style === 'forms') {
      items.array.forEach((value) => {
        value.model = this.showProp(value.prop, res)
      })
    } else if (items.style === 'upload') {
      // 判断有没有设置取值名称
      // const newLabel = (items.prop) ? items.prop : 'files'
      if (res[items.prop] !== undefined && res[items.prop] !== null) {
        // 判断类型是否为数组
        if (res[items.prop].constructor === Array) {
          items.model = res[items.prop]
        } else {
          items.model = [res[items.prop]]
        }
      } else {
        items.model = []
      }
    } else if (items.style === 'maps') {
      items.model = this.showProp(items.prop, res)
      items.model2 = this.showProp(items.prop2, res)
      items.model3 = this.showProp(items.prop3, res)
    } else {
      // 编辑器类型
      items.model = this.showProp(items.prop, res)
    }
  })
  return grForms
}
// 处理上面的结构 [1.取值结构 2.接口结构]
Vue.prototype.showProp = function (prop, items) {
  let model = ''
  if (typeof prop === 'string') {
    model = items[prop]
  } else {
    // 根据层级取值
    switch (prop.length) {
      case 1:
        model = items[prop[0]]
        break
      case 2:
        model = items[prop[0]][prop[1]]
        break
      case 3:
        model = items[prop[0]][prop[1]][prop[2]]
        break
      default:
        model = items[prop[0]][prop[1]][prop[2]][prop[3]]
    }
  }
  return model !== undefined ? model : ''
}
// 接口要的结构 [1.取值结构]
Vue.prototype.structureFace = function (grForms) {
  let arrayHandle = {}
  grForms.forEach((items) => {
    if (items.style === 'forms') {
      items.array.forEach((value) => {
        this.faceProp(value, arrayHandle)
      })
    } else if (items.style === 'upload') {
      let prop = items.deliver === undefined ? items.prop : items.deliver
      // 【1.普通类型-存文件id】 【2.商品类型-指定存储结构】 【3.路径类型-存相对路径】
      if (items.level === undefined || items.level === 1) {
        if (items.model.length === 0) {
          arrayHandle[prop] = 0
        } else if (items.model.length === 1) {
          arrayHandle[prop] = items.limit === 1 ? items.model[0].id : [items.model[0].id]
        } else {
          const imageID = []
          items.model.forEach((value) => {
            imageID.push(value.id)
          })
          arrayHandle[prop] = imageID
        }
      } else if (items.level === 2 || items.level === 4) {
        // 购物商城独有
        arrayHandle[prop] = []
      } else {
        if (items.model.length === 0) {
          arrayHandle[prop] = ''
        } else if (items.model.length === 1) {
          arrayHandle[prop] = items.limit === 1 ? items.model[0] : [items.model[0]]
        } else {
          const imageUrl = []
          items.model.forEach((value) => {
            imageUrl.push(value)
          })
          arrayHandle[prop] = imageUrl
        }
      }
    } else if (items.style === 'maps') {
      arrayHandle[items.prop] = items.model
      arrayHandle[items.prop2] = items.model2
      arrayHandle[items.prop3] = items.model3
    } else {
      this.faceProp(items, arrayHandle)
    }
  })
  return arrayHandle
}
// 处理上面的结构 [1.取值结构 2.最终结构]
Vue.prototype.faceProp = function (value, arrayHandle) {
  // 如果该值不等于true 就不需要处理
  if (value.show !== undefined) {
    if (value.show === false) {
      return ''
    }
  }
  let prop = value.deliver === undefined ? value.prop : value.deliver
  if (typeof prop === 'string') {
    arrayHandle[prop] = value.model
  } else {
    // 根据层级取值
    switch (prop.length) {
      case 1:
        arrayHandle[prop[0]] = value.model
        break
      case 2:
        // 不存在就创建
        if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
        // 赋值
        arrayHandle[prop[0]][prop[1]] = value.model
        break
      case 3:
        // 不存在就创建
        if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
        if (arrayHandle[prop[0]][prop[1]] === undefined) { arrayHandle[prop[0]][prop[1]] = {} }
        // 赋值
        arrayHandle[prop[0]][prop[1]][prop[2]] = value.model
        break
      default:
        // 不存在就创建
        if (arrayHandle[prop[0]] === undefined) { arrayHandle[prop[0]] = {} }
        if (arrayHandle[prop[0]][prop[1]] === undefined) { arrayHandle[prop[0]][prop[1]] = {} }
        if (arrayHandle[prop[0]][prop[1]][prop[2]] === undefined) { arrayHandle[prop[0]][prop[1]][prop[2]] = {} }
        arrayHandle[prop[0]][prop[1]][prop[2]][prop[3]] = value.model
    }
  }
  return arrayHandle
}

// 验证必填项
Vue.prototype.validationMust = function (structure) {
  let textArray = ''
  structure.forEach((items) => {
    if (items.array !== undefined) {
      items.array.forEach((value) => {
        if (value.must !== undefined && value.must === true) {
          if (value.model === null || value.model.length === 0) {
            textArray = textArray + '[ ' + value.title + ' ] '
          }
        }
      })
    } else {
      if (items.must !== undefined && items.must === true) {
        if (items.model === null || items.model.length === 0) {
          textArray = textArray + '[ ' + items.title + ' ] '
        }
      }
    }
  })
  if (textArray !== '') {
    this.$message({type: 'error', customClass: 'messageNew', message: textArray + '为必须填写'})
    return false
  }
  return true
}

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js